import { GrpcCurrency } from '@m/types/grpc/GrpcTypes';

export enum EnforcementStatus {
  OK = 'OK',
  Notice = 'Notice',
  Violation = 'Violation',
}

export type EnforcementLookup = {
  coveredBySubscription: boolean;
  enforcementStatus: EnforcementStatus;
  imageUrl?: string; // undefined when searching by plate text
  isMember: boolean;
  plateText: string;
  specialistInstructions: string;
  user?: {
    firstName: string | null;
    isRegistered: boolean;
    lastName: string | null;
  };
};

export type EnforcementPlan = {
  fineAmount: GrpcCurrency;
  minimumVisitDurationMinutes?: number;
  name: string;
  planId: string;
  versionDate: string;
};

export type ZoneEnforcementPlanDetails = {
  enforcementPlanId: string;
  enforcementStartDate: number;
  fineAmount: number;
  isPaused: boolean;
  mailNotices: boolean;
  versionDate: string;
};
